var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3297_11290",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4232 15.9225C16.267 16.0788 16.055 16.1666 15.834 16.1666H4.16732C3.9463 16.1666 3.73434 16.0788 3.57806 15.9225C3.42178 15.7662 3.33398 15.5543 3.33398 15.3333V3.66659C3.33398 3.44557 3.42178 3.23361 3.57806 3.07733C3.73434 2.92105 3.9463 2.83325 4.16732 2.83325H11.3257C11.5443 2.83417 11.7538 2.92097 11.909 3.07492L14.1673 5.33325L16.4257 7.59159C16.5796 7.7468 16.6664 7.9563 16.6673 8.17492V15.3333C16.6673 15.5543 16.5795 15.7662 16.4232 15.9225ZM5.00065 14.4999V8.66659H15.0007V14.4999H5.00065ZM14.1673 10.3333H5.83398V11.1666H14.1673V10.3333ZM14.1673 12.8333H5.83398V13.6666H14.1673V12.8333ZM5.00065 3.66659H10.0007V6.16659H5.00065V3.66659Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3297_11290)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.5,
    width: 20,
    height: 20,
    fill: "#07B464"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/download_file.dfbd0d28ffeba11fe176069d3e4df27f.svg";
export { ForwardRef as ReactComponent };